// src/pages/misSolicitudesBeneficios/TableCatalogItems.jsx
import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons"; // opcional, si quieres un ícono en el overlay

// Las fechas del catálogo llegan como string en dos formatos según el origen de la
// campaña: "2026-09-03" (BENEFICIO) y "2026-09-03 0:0" (TAILOY/PENSIONESCOLAR/CUPONERA).
// No se debe usar new Date(): el formato solo-fecha se parsea como UTC y al renderizarlo
// en Lima (UTC-5) retrocede un día. Se formatea el string directamente.
const formatFechaCatalogo = (valor) => {
  if (!valor) return null;
  const partes = /^(\d{4})-(\d{2})-(\d{2})/.exec(valor);
  return partes ? `${partes[3]}/${partes[2]}/${partes[1]}` : valor;
};

const TableCatalogItems = ({
  rows = [], // ← recibe formCatalogValues.Items
  handleSelectCampania, // ← función que se ejecuta al hacer click en "Seleccionar"
  isFetching = false,
}) => {
  if (isFetching) {
    return (
      <div className="d-flex justify-content-center" style={{ height: "60vh" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Cargando...</span>
        </div>
      </div>
    );
  }

  if (!rows.length) {
    return (
      <div className="text-center py-5 blue-standard-color">
        Por ahora no contamos con ninguna campaña vigente, espera novedades próximamente
      </div>
    );
  }

  return (
    <CustomWrapper>
      {rows.map((campania) => (
        <Card key={campania.IdCampania || campania.id}>

          <Title>{campania.Descripcion || "Campaña sin nombre"}</Title>
            <SubTitle>
            {campania.FechaInicio && campania.FechaFin 
                ? `Del ${formatFechaCatalogo(campania.FechaInicio)} al ${formatFechaCatalogo(campania.FechaFin)}`
                : "Fechas por confirmar"}
            </SubTitle>

          <ImageContainer>
            <CampaniaImage
              src={campania.ImgSrc || campania.ImagenUrl || "/img/default-campania.jpg"}
              alt={campania.Descripcion}
            />
            <Overlay>
              <OverlayText>
                {campania.TextoDescriptivo || "Sin descripción disponible"}
              </OverlayText>
            </Overlay>
          </ImageContainer>

          <SelectButton onClick={() => handleSelectCampania(campania)}>
            SELECCIONAR
          </SelectButton>
        </Card>
      ))}
    </CustomWrapper>
  );
};

export default TableCatalogItems;

// ======================= STYLED COMPONENTS =======================

const CustomWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 30px;
  padding: 20px;
  justify-items: center;
`;

const Card = styled.div`
  width: 320px;
  height: 520px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 12px 20px rgba(0, 0, 0, 0.15);
  }
`;

const Title = styled.div`
  height: 80px;
  padding: 15px;
  text-align: center;
  font-weight: 700;
  font-size: 20px;
  color: #003087;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
  border-bottom: 1px solid #eee;
`;

const ImageContainer = styled.div`
  position: relative;
  flex: 1;
  overflow: hidden;
`;

const CampaniaImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease;
  
  ${Card}:hover & {
    transform: scale(1.05);
  }
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 48, 135, 0.85);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  visibility: hidden;
  transition: all 0.4s ease;
  padding: 20px;
  text-align: center;

  ${Card}:hover & {
    opacity: 1;
    visibility: visible;
  }
`;

const OverlayText = styled.p`
  font-size: 16px;
  line-height: 1.5;
  margin: 0;
`;

const SelectButton = styled.button`
  height: 60px;
  background: #003087;
  color: white;
  border: none;
  font-weight: 600;
  font-size: 18px;
  cursor: pointer;
  transition: background 0.3s ease;

  &:hover {
    background: #0050b3;
  }

  &:active {
    background: #002766;
  }
`;

const SubTitle = styled.div`
  font-size: 14px;
  color: #666;
  padding: 0 15px 10px;
  text-align: center;
`;